export default __webpack_public_path__ + "static/jameelMotorsLogo-b60ee44ad6f288dec4229427165dfdc9.svg";